import { fundingReportMatches } from './types';

export * from './actions';

const fundingReportMatchesReducerObject = {
  [fundingReportMatches.error]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['matches', 'network', 'error'], true)
        .setIn(['matches', 'network', 'loading'], false)
        .setIn(['matches', 'network', 'success'], false),
    ),
  [fundingReportMatches.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['matches', 'network', 'loading'], true)
        .setIn(['matches', 'network', 'success'], false),
    ),
  [fundingReportMatches.success]: (state, { response }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['matches', 'data'], response)
        .setIn(['matches', 'network', 'loading'], false)
        .setIn(['matches', 'network', 'success'], true),
    ),
};

export default fundingReportMatchesReducerObject;
